import { useTranslation } from 'react-i18next';
/////////////////////////////////////////////////////////////
import { useCustomSelector } from '@/core/redux/hooks';
import { LevelInfoItem } from './components';

interface LevelInfoProps {}

export const LevelsInfo: React.FC<LevelInfoProps> = ({}: LevelInfoProps) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Redux
	**********************/
	const { levelsRequeriments } = useCustomSelector((state) => state.counter);

	/*********************
	// #region Template
	**********************/
	return (
		<>
			<div className="grid grid-cols-4 mt-6">
				<div className="col-span-1">
					<p className="pl-3">{t('friends.mascotName')}</p>
				</div>
				<div className="col-span-2 pl-2">
					<p>{t('friends.level')}</p>
				</div>
				<div>
					<p>{t('friends.forFriend')}</p>
				</div>
			</div>

			<div className="flex flex-col gap-3 mt-6">
				{levelsRequeriments.map((level) => {
					return (
						<LevelInfoItem
							key={level.name}
							level={level.level}
							image={level.image}
							name={level.name.replace(/\(.*?\)/, '')}
							friendReward={parseInt(level.bonus.toString())}
							gradient={`bg-level-gradient-${level.level}`}
						/>
					);
				})}
			</div>
		</>
	);
};
